import React, { Component } from 'react';
//i18n
import { withNamespaces } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';

class NakireSGTSidebarContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem('authUser')),
    };
  }

  render() {
    if (this.state.user.role_id < 3) {
      return (
        <React.Fragment>
          <li className="menu-title">{this.props.t('Configuración')}</li>
          <li>
            <Link to="users" className="waves-effect">
              <i className="bx bx-user-circle"></i>
              <span>{this.props.t('Usuarios')}</span>
            </Link>
          </li>

          <li>
            <Link to="/#" className="waves-effect">
              <i className="bx bx-slider"></i>
              <span>{this.props.t('Dispositivos')}</span>
            </Link>

            <ul className="sub-menu" aria-expanded="false">
              <li>
                <Link to="/dmxDeviceProfiles">
                  <i className="mdi mdi-subdirectory-arrow-right" />
                  {this.props.t('Perfiles DMX')}
                </Link>
              </li>
              <li>
                <Link to="/dmxControllers">
                  <i className="mdi mdi-subdirectory-arrow-right" />
                  {this.props.t('Controladores DMX')}
                </Link>
              </li>
            </ul>
          </li>

          <li>
            <Link to="/#" className="waves-effect">
              <i className="bx bx-shield-alt-2"></i>
              <span>{this.props.t('PLC Safety')}</span>
            </Link>

            <ul className="sub-menu" aria-expanded="false">
              <li>
                <Link to="/parameters">
                  <i className="mdi mdi-subdirectory-arrow-right" />
                  {this.props.t('Parámetros del PLC')}
                </Link>
              </li>
              <li>
                <Link to="/plcSafetyCauses">
                  <i className="mdi mdi-subdirectory-arrow-right" />
                  {this.props.t('Histórico de causas')}
                </Link>
              </li>
              <li>
                <Link to="/plcSafetyEvents">
                  <i className="mdi mdi-subdirectory-arrow-right" />
                  {this.props.t('Eventos')}
                </Link>
              </li>
              <li>
                <Link to="/plcSafetyTriggers">
                  <i className="mdi mdi-subdirectory-arrow-right" />
                  {this.props.t('Triggers')}
                </Link>
              </li>
              <li>
                <Link to="/plcSafetyZoneDependencies">
                  <i className="mdi mdi-subdirectory-arrow-right" />
                  {this.props.t('Dependencias entre zonas')}
                </Link>
              </li>
              <li>
                <Link to="/plcResyncSecurities">
                  <i className="mdi mdi-subdirectory-arrow-right" />
                  {this.props.t('Resincronización PLC')}
                </Link>
              </li>
            </ul>
          </li>
          <li>
            <Link to="/#" className="waves-effect">
              <i className="bx bxs-cog"></i>
              <span>{this.props.t('Parámetros')}</span>
            </Link>

            <ul className="sub-menu" aria-expanded="false">
              <li>
                <Link to="/settings-global">
                  <i className="mdi mdi-subdirectory-arrow-right" />
                  {this.props.t('Globales')}
                </Link>
              </li>
              <li>
                <Link to="/entry-strategies">
                  <i className="mdi mdi-subdirectory-arrow-right" />
                  {this.props.t('Estrategias de entrada')}
                </Link>
              </li>
              <li>
                <Link to="/settings-data-retention">
                  <i className="mdi mdi-subdirectory-arrow-right" />
                  {this.props.t('Retención de datos')}
                </Link>
              </li>
            </ul>
          </li>
        </React.Fragment>
      );
    } else {
      return null;
    }
  }
}

export default withRouter(withNamespaces()(NakireSGTSidebarContent));
